// extracted by mini-css-extract-plugin
export default {"page":"ProductCatalog_page__G7wRA","volverButton":"ProductCatalog_volverButton__I7Hat","grid":"ProductCatalog_grid__C1YnM"};